import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
// import { Injector } from '@angular/core';
// import { AppInitService } from './service/appinit/app-init.service';
import { AuthenticationService } from '@service/admin-console/authentication/authentication.service';
import { SelectedInstituteService } from '@shared/service/selected-institute.service';

// const injector = Injector.create({
//     providers: [
//       { provide: AuthenticationService, useClass: AuthenticationService, deps: [] },
//       { provide: SelectedInstituteService, useClass: SelectedInstituteService, deps: [] },
//       { provide: AppInitService, useClass: AppInitService, deps: [AuthenticationService, SelectedInstituteService] },
//     ]
//   });
// const appInitService = injector.get(AppInitService);

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));

// appInitService.initializeApp()
//   .then(() => {
//     bootstrapApplication(AppComponent, appConfig)
//       .catch(err => console.error(err));
//   })
//   .catch(error => {
//     console.error('App initialization failed', error);
//     bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
//   });
